"use strict";
// TODO: button hover color could be derived from its based color by applying something like opacity/darkening
// same goes for gradients
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME = void 0;
exports.THEME = {
    light: {
        THEME: 'light',
        BG_GREEN: '#39a814',
        BG_LIGHT_GREEN: '#effaec',
        BG_SECONDARY: '#effaec',
        BG_SECONDARY_HOVER: '#e8f3e5',
        BG_GREEN_HOVER: '#339714',
        BG_LIGHT_GREEN_HOVER: '#e8f3e5',
        BG_GREY: '#f4f4f4',
        BG_GREY_OPEN: '#f4f4f4',
        BG_GREY_ALT: '#f4f4f4',
        BG_LIGHT_GREY: '#fcfcfc',
        BG_WHITE: '#ffffff',
        BG_WHITE_ALT: '#ffffff',
        BG_WHITE_ALT_HOVER: '#f4f4f4',
        BG_RED: '#d04949',
        BG_LIGHT_RED: '#F6E2E2',
        BG_TOOLTIP: '#212223',
        BG_TOOLTIP_BORDER: '#3a3b3c',
        BG_ICON: 'transparent',
        TYPE_GREEN: '#279503',
        TYPE_ORANGE: '#c19009',
        TYPE_BLUE: '#1d88c5',
        TYPE_RED: '#cd4949',
        TYPE_DARK_GREY: '#404040',
        TYPE_LIGHT_GREY: '#808080',
        TYPE_LIGHTER_GREY: '#bdbdbd',
        TYPE_WHITE: '#ffffff',
        STROKE_GREY: '#e8e8e8',
        STROKE_GREY_ALT: '#e8e8e8',
        STROKE_LIGHT_GREY: '#f4f4f4',
        BUTTON_RED: '#cd4949',
        BUTTON_RED_HOVER: '#b93c3c',
        GRADIENT_SKELETON_START: '#eaeaea',
        GRADIENT_GREEN_START: '#39a814',
        GRADIENT_GREEN_END: '#4cbc26',
        GRADIENT_RED_START: '#d15b5b',
        GRADIENT_RED_END: '#e75f5f',
        BOX_SHADOW_BLACK_5: 'rgba(0, 0, 0, 0.05)',
        BOX_SHADOW_BLACK_15: 'rgba(0, 0, 0, 0.15)',
        BOX_SHADOW_BLACK_20: 'rgba(0, 0, 0, 0.2)',
        BOX_SHADOW_MODAL: 'rgba(77, 77, 77, 0.2)',
        BOX_SHADOW_OPTION_CARD: 'rgba(77, 77, 77, 0.12)',
        HOVER_PRIMER_COLOR: '#000',
        HOVER_TRANSPARENTIZE_FILTER: 0.96,
        HOVER_DARKEN_FILTER: 0.04,
        HOVER_TRANSITION_TIME: '150ms',
        HOVER_TRANSITION_EFFECT: 'ease-out',
    },
    dark: {
        THEME: 'dark',
        BG_GREEN: '#5ea447',
        BG_GREEN_HOVER: '#4e883b',
        BG_LIGHT_GREEN: '#1a2516',
        BG_SECONDARY: '#3a3b3c',
        BG_SECONDARY_HOVER: '#373839',
        BG_LIGHT_GREEN_HOVER: '#131d10',
        BG_GREY: '#18191a',
        BG_GREY_OPEN: '#141414',
        BG_GREY_ALT: '#3a3b3c',
        BG_LIGHT_GREY: '#212223',
        BG_WHITE: '#242526',
        BG_WHITE_ALT: '#3a3b3c',
        BG_WHITE_ALT_HOVER: '#444546',
        BG_RED: '#ab2626',
        BG_LIGHT_RED: '#5a1616',
        BG_TOOLTIP: '#3a3b3c',
        BG_ICON: '#ffffff',
        TYPE_GREEN: '#66ab4e',
        TYPE_ORANGE: '#9b813b',
        TYPE_BLUE: '#197eaa',
        TYPE_RED: '#c65353',
        TYPE_DARK_GREY: '#eaebed',
        TYPE_LIGHT_GREY: '#959596',
        TYPE_LIGHTER_GREY: '#bdbdbd',
        TYPE_WHITE: '#fafafa',
        STROKE_GREY: '#3a3b3c',
        STROKE_GREY_ALT: '#5c5d5e',
        STROKE_LIGHT_GREY: '#3a3b3c',
        BUTTON_RED: '#cd4949',
        BUTTON_RED_HOVER: '#b93c3c',
        GRADIENT_SKELETON_START: '#272729',
        // these gradients are used on transaction graph only
        GRADIENT_GREEN_START: '#559c3d',
        GRADIENT_GREEN_END: '#5fa548',
        GRADIENT_RED_START: '#d15b5b',
        GRADIENT_RED_END: '#e75f5f',
        BOX_SHADOW_BLACK_5: 'rgba(255, 255, 255, 0.05)',
        BOX_SHADOW_BLACK_15: 'rgba(0, 0, 0, 0.2)',
        BOX_SHADOW_BLACK_20: 'rgba(0, 0, 0, 0.2)',
        BOX_SHADOW_MODAL: 'rgba(0, 0, 0, 0.5)',
        BOX_SHADOW_OPTION_CARD: 'rgba(0, 0, 0, 0.2)',
        IMAGE_FILTER: 'brightness(0.8) contrast(1.2) saturate(1.2)',
        HOVER_PRIMER_COLOR: '#fff',
        HOVER_TRANSPARENTIZE_FILTER: 0.96,
        HOVER_DARKEN_FILTER: -0.04,
        HOVER_TRANSITION_TIME: '150ms',
        HOVER_TRANSITION_EFFECT: 'ease-out',
    },
    // black theme is not used currently, but will be in the future
    black: {
        THEME: 'black',
        BG_GREEN: '#5ea447',
        BG_GREEN_HOVER: '#4e883b',
        BG_LIGHT_GREEN: '#1a2516',
        BG_LIGHT_GREEN_HOVER: '#131d10',
        BG_SECONDARY: '#3a3b3c',
        BG_SECONDARY_HOVER: '#373839',
        BG_GREY: '#000000',
        BG_GREY_OPEN: '#141414',
        BG_GREY_ALT: '#262626',
        BG_LIGHT_GREY: '#0c0c0c',
        BG_WHITE: '#101010',
        BG_WHITE_ALT: '#3a3b3c',
        BG_WHITE_ALT_HOVER: '#444546',
        BG_RED: '#ab2626',
        BG_LIGHT_RED: '#5a1616',
        BG_TOOLTIP: '#151524',
        BG_ICON: '#ffffff',
        TYPE_GREEN: '#6fa95c',
        TYPE_ORANGE: '#9b813b',
        TYPE_BLUE: '#197eaa',
        TYPE_RED: '#c65353',
        TYPE_DARK_GREY: '#fafafa',
        TYPE_LIGHT_GREY: '#8e8e8e',
        TYPE_LIGHTER_GREY: '#bdbdbd',
        TYPE_WHITE: '#fafafa',
        STROKE_GREY: '#262626',
        STROKE_GREY_ALT: '#262626',
        STROKE_LIGHT_GREY: '#1a1a1a',
        BUTTON_RED: '#cd4949',
        BUTTON_RED_HOVER: '#b93c3c',
        GRADIENT_SKELETON_START: '#272729',
        // these gradients are used on transaction graph only
        GRADIENT_GREEN_START: '#559c3d',
        GRADIENT_GREEN_END: '#5fa548',
        GRADIENT_RED_START: '#d15b5b',
        GRADIENT_RED_END: '#e75f5f',
        BOX_SHADOW_BLACK_5: 'rgba(255, 255, 255, 0.05)',
        BOX_SHADOW_BLACK_15: 'rgba(0, 0, 0, 0.2)',
        BOX_SHADOW_BLACK_20: 'rgba(255, 255, 255, 0.1)',
        BOX_SHADOW_MODAL: 'rgba(0, 0, 0, 0.5)',
        BOX_SHADOW_OPTION_CARD: 'rgba(0, 0, 0, 0.2)',
        IMAGE_FILTER: 'brightness(0.8) contrast(1.2) saturate(1.2)',
        HOVER_PRIMER_COLOR: '#fff',
        HOVER_TRANSPARENTIZE_FILTER: 0.96,
        HOVER_DARKEN_FILTER: -0.04,
        HOVER_TRANSITION_TIME: '150ms',
        HOVER_TRANSITION_EFFECT: 'ease-out',
    },
};
var oldColors = {
    // TODO: some colors from old design that are waiting to be reworked into NEUE design
    GREEN: '#30C101',
    YELLOW: '#fdcb33',
    RED: '#cd4949',
};
var colors = __assign(__assign({}, oldColors), exports.THEME.light);
exports.default = colors;
